import SelectBox from "../../SelectBox";
import React from "react";

export const ItemPropertySelect = (props) => {
    const {onSelect, selectValue, selectArray} = props;
    return (
        <SelectBox
            handleChangeSelect={onSelect}
            selectValue={selectValue}
            selectArray={selectArray}
            className="editorial-field editorial-table-select"
        />
    )
}